// Small “EZ” monogram icon for ezlocal.com.
export default function EzLocalIcon({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <text
        x="50%"
        y="58%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontFamily="Inter, sans-serif"
        fontWeight="800"
        fontSize="12"
        fill="currentColor"
        letterSpacing="-.5"
      >
        ez
      </text>
    </svg>
  );
}
